import I18n from 'I18n';
import { VALIDATION_ERRORS } from 'personalization-lib/constants/validation';
export const getValidationErrorMessage = (validationErrors, assetType) => {
  if (!validationErrors.size) {
    return undefined;
  }
  if (validationErrors.has(VALIDATION_ERRORS.MISSING_PERSONALIZE_EDIT_SCOPE)) {
    return I18n.text('personalizationLib.shared.tooltips.noPersonalizeEditScope');
  }
  if (validationErrors.has(VALIDATION_ERRORS.MISSING_ASSET_AI_SCOPE) || validationErrors.has(VALIDATION_ERRORS.GENERATIVE_AI_DISABLED)) {
    return I18n.text('personalizationLib.shared.tooltips.noGenAIAccess');
  }
  if (validationErrors.has(VALIDATION_ERRORS.NO_WRITE_SCOPE)) {
    return I18n.text('personalizationLib.shared.tooltips.noAvailableAssetTypes');
  }
  if (validationErrors.has(VALIDATION_ERRORS.MISSING_ASSET_WRITE_SCOPE)) {
    return I18n.text(`personalizationLib.shared.tooltips.assetAccess.create.${assetType.toString()}`);
  }
  if (validationErrors.has(VALIDATION_ERRORS.STRATEGY_LIMIT_REACHED)) {
    return I18n.text('personalizationLib.shared.tooltips.maxStrategiesReached');
  }
  if (validationErrors.has(VALIDATION_ERRORS.STRATEGY_VARIANT_LIMIT_REACHED)) {
    return I18n.text('personalizationLib.shared.tooltips.maxVariantsReached');
  }
  if (validationErrors.has(VALIDATION_ERRORS.ASSET_NOT_PERSONALIZABLE)) {
    return I18n.text('personalizationLib.shared.tooltips.assetCannotBePersonalized');
  }
  if (validationErrors.has(VALIDATION_ERRORS.UNSUPPORTED_ASSET_TYPE)) {
    return I18n.text('personalizationLib.shared.tooltips.unsupportedAssetType');
  }
  return undefined;
};